import { forwardRef } from 'react';

import { Box, Button as ButtonMui } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import clsx from 'clsx';

import { IButtonProps as IProps } from './types';

import styles from './Button.module.scss';

export const Button = forwardRef<HTMLButtonElement, IProps>(({ isLoading = false, loaderClassName, buttonClassName, children, ...props }, ref) => {
  return (
    <ButtonMui disabled={isLoading} {...props} className={clsx(props.className, { loadingButton: isLoading })} ref={ref}>
      {isLoading && (
        <CircularProgress
          color="inherit"
          size={18}
          className={clsx(styles.loader, loaderClassName && loaderClassName)}
        />
      )}
      {children && <Box className={clsx(styles.buttonContent, { [styles.buttonTextHidden]: isLoading }, buttonClassName)}>
        {children}
      </Box>}
    </ButtonMui>
  );
});
